import React from 'react';
import Link from 'next/link';
import SupportSideNavStyles from './SupportSideNavStyles';
import SearchBar from '../SearchBar';

const SupportSideNav = ({ noPadding }) => {
  return (
    <SupportSideNavStyles noPadding={noPadding}>
      <div className="sidenav-container">
        <SearchBar />
        <div className="popular-container">
          <div className="popular-title-container">
            <img src="/icons/trending-up.svg" />
            <div className="popular-title">
              Popular
            </div>
          </div>
          <div className="popular-links">
            <div className="link-wrapper">
              <Link href="/support/return-status">
                <a className="link">Check My Tax Return Status</a>
              </Link>
            </div>
            <div className="link-wrapper">
              <Link href="/support/appointment">
                <a className="link">Schedule an Appointment with Your Accounting Team</a>
              </Link>
            </div>
            <div className="link-wrapper">
              <Link href="/support/billing">
                <a className="link"> Request Billing support</a>
              </Link>
            </div>
          </div>
          <div className="all-sections-container">
            <div className="all-sections-title">
              All Sections
            </div>
            <div className='all-sections-links'>
              <div className="link-wrapper">
                <Link href="/support/faq-general">
                  <a className="link">General</a>
                </Link>
              </div>
              <div className="link-wrapper">
                <Link href="/support/faq-billing">
                  <a className="link">Billing</a>
                </Link>
              </div>
              <div className="link-wrapper">
                <Link href="/support/faq-accounting">
                  <a className="link">Accounting</a>
                </Link>
              </div>
              <div className="link-wrapper">
                <Link href="/support/faq-bookkeeping">
                  <a className="link">Bookkeeping</a>
                </Link>
              </div>
              <div className="link-wrapper">
                <Link href="/support/faq-payroll">
                  <a className="link">Payroll</a>
                </Link>
              </div>
              <div className="link-wrapper">
                <Link href="/support/faq-entity-formation">
                  <a className="link">Entity Formation</a>
                </Link>
              </div>
              <div className="link-wrapper">
                <Link href="/support/contact-us">
                  <a className="link">Contact Us</a>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SupportSideNavStyles>
  );
};

export default SupportSideNav;